module.exports = __webpack_public_path__ + "media/images/landing/avatar2-7526540d4582766c73cee8641b9b2ac1.jpg";